import Openable from 'utils/lib/openable';

class Modal extends Openable {
  constructor(element: string | HTMLElement, useOverlay = true) {
    super(element, useOverlay);

    this.classes = {
      active: 'modal--active',
    };
  }
}

export default (element: string | HTMLElement, useOverlay = true): Modal => (
  new Modal(element, useOverlay)
);
